/// <amd-module name="Wit/UI/Enums" />
/**
 * Display mode of an identity
 */
export const enum IdentityDisplayMode {
    AvatarAndName,
    AvatarOnly,
    NameOnly
}
